<template>
  <div>
    <div class="jumbotron">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#/home">Home</a></li>
        <li class="breadcrumb-item active">Schema Access</li>
      </ol>
    </div>

    <div class="row">
      <div class="col">
        <blockquote class="blockquote">
          <form>
            <fieldset>
              <legend>Grant Schema Access</legend>

              <fieldset class="form-group">
                <legend>Mode</legend>
                <div class="form-check">
                  <label class="form-check-label">
                    <input
                      id="optionsRadios1"
                      name="optionsRadios"
                      type="radio"
                      v-model="modeRadio"
                      class="form-check-input"
                      value="migrate">
                    <span class="badge badge-primary badge-pill">Migrate</span>
                  </label>
                </div>
                <div class="form-check">
                  <label class="form-check-label">
                      <input 
                        id="optionsRadios2"
                        name="optionsRadios"
                        type="radio"
                        v-model="modeRadio"
                        class="form-check-input"
                        value="generate">
                      <span class="badge badge-default badge-pill">Generate SQL</span>
                  </label>
                </div>
              </fieldset>

              <div class="form-group">
                <div class="input-group">
                  <label class="col-4 col-form-label">Team</label>
                  <select v-model="teamUser" id="selectTeamName"
                          class="custom-select form-control">
                      <option v-for="entry in teamNames">
                          {{ entry }}
                      </option>
                  </select>
                </div>
              </div>
              <div v-if="modeRadio === 'migrate'" class="form-group">
                <div class="input-group">
                  <label class="col-4 col-form-label">Data Source</label>
                  <select v-model="dataSource" class="custom-select form-control">
                      <option v-for="entry in dataSources" v-bind:value="entry.dataSource">
                          {{ entry.dataSource.heliumDataSourceName }}
                      </option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <div class="input-group">
                  <label class="col-4 col-form-label">Schema Name</label>
                  <input 
                    v-if="modeRadio !== 'migrate'"
                    v-model="schemaName"
                    class="form-control"
                    type="text">
                  <select
                    v-if="modeRadio === 'migrate'"
                    v-model="schemaName" class="custom-select form-control">
                      <option v-for="entry in appList">
                          {{ entry.schemaName }}
                      </option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <div class="btn-group pull-right">
                  <button type="button"
                    class="btn btn-sm btn-secondary"
                    @click="resetData">
                    <i class="fa fa-times" aria-hidden="true"></i>
                    Clear selection
                  </button>
                  <button type="button"
                    class="btn btn-primary btn-md"
                    data-toggle="tooltip"
                    title="Alter all obects in the schema name for the selected server to be owned by the selected team"
                    v-on:click="grantAccess"
                    v-if="modeRadio === 'migrate'">
                    <i class="fa fa-upload" aria-hidden="true"></i>
                    Grant Access
                  </button>
                  <button type="button"
                    class="btn btn-secondary btn-md"
                    data-toggle="tooltip"
                    title="Generate the SQL required to migrate the schema to the team"
                    v-on:click="generateSql"
                    v-else>
                    <i class="fa fa-file-text" aria-hidden="true"></i>
                    Generate SQL
                  </button>
                </div>
              </div>
            </fieldset>
          </form>
        </blockquote>
      </div>
      <div class="col">
        <div id="schema-access-info" class="alert alert-info pull-right" role="alert">
          <i class="fa fa-info-circle" aria-hidden="true"></i>
          <strong>Postgres Permissions</strong><br>
          <p>By default developer's postgres users to not have permissions to view or update the data and schema of a Helium app</p>
          <strong>Connection Status</strong><br>
        </div>
        <table class="table table-sm table-striped table-hover">
          <thead class="thead-inverse">
            <tr>
              <th>Data Source</th>
              <th>Ping Status</th>
            </tr>
          <thead/>
          <tbody>
            <tr v-for="entry in dataSources"
                :class="entry.response === 'Ping successful' ? '' : 'table-warning'">
              <td>{{ entry.heliumDataSourceName }}</td>
              <td>{{ entry.response }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div ref="resultsRef" class="container-fluid">
      <div id="resultsDiv" v-if="response"
        class="card card-block card-outline-primary">
        <div class="card-title">
          <div class="row">
            <div class="col">
              <h4>Results</h4>
            </div>
            <div class="form-inline float-right">
              <button id="copyToClipBtn" type="button" class="btn btn-primary"
                data-toggle="tooltip" title="Copy SQL to your clipboard!"
                v-if="textBlock"
                v-clipboard:copy="textBlock"
                v-clipboard:success="onCopy">
                <i class="fa fa-clipboard"></i>
              </button>
            </div>
          </div>
        </div>
        <text-editor
          v-if="modeRadio === 'generate'"
          v-bind:contentProp="textBlock"
          v-bind:width="textBlockWidth"
          v-bind:height="textBlockHeight"
          v-bind:readonly="textBlockReadOnly"
          v-bind:scrollToLine="textBlockScrollToLine"
          v-bind:lang="textBlockLang"></text-editor>
      </div>
    </div> 
  </div>

</template>

<script>
  import TextEditor from '@/components/TextEditor.vue'
  export default {
    name: 'SchemaAccess',
    components: {
      TextEditor
    },
    data: function () {
      return {
        dataSource: null,
        dataSources: [],
        teamNames: [],
        teamUser: '',
        schemaName: '',
        response: null,
        actions: [],
        textBlockWidth: 0,
        textBlockHeight: 0,
        textBlockReadOnly: false,
        textBlockScrollToLine: 0,
        modeRadio: 'migrate',
        textBlockLang: 'sql',
        appList: []
      }
    },
    methods: {
      getDatabaseServers: function () {
        let vm = this
        vm.$parent.environment.dataSources.forEach(function (dataSource) {
          vm.pingDatabase(dataSource)
        })
      },
      getTeams: function () {
        let vm = this
        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/schema-access/team-names'
        vm.axios.post(endpoint)
          .then(function (response) {
            vm.teamNames = response.data
          })
          .catch(function (error) {
            let obj = {
              title: 'Unable to find team names',
              message: error,
              type: 'error'
            }
            vm.$Simplert.open(obj)
          })
      },
      pingDatabase: function (dataSource) {
        let vm = this
        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/schema-access/ping-database'
        var config = {}
        config['environment'] = vm.$parent.environment.name
        config['dataSource'] = dataSource
        vm.axios.post(endpoint, config)
          .then(function (response) {
            var element = {}
            element['heliumDataSourceName'] = dataSource.heliumDataSourceName
            element['response'] = response.data.response
            element['dataSource'] = dataSource
            vm.dataSources.push(element)
          })
          .catch(function (error) {
            var element = {}
            element['heliumDataSourceName'] = dataSource.heliumDataSourceName
            element['response'] = error.response.data.response
            vm.dataSources.push(element)
            let obj = {
              title: 'Unable to ping database',
              message: error,
              type: 'error'
            }
            vm.$Simplert.open(obj)
          })
      },
      grantAccess: function () {
        let vm = this
        vm.showFeedback = true
        vm.actions = []
        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/schema-access/migrate-schema'
        var config = {}
        config['environment'] = vm.$parent.environment.name
        config['dataSource'] = vm.dataSource
        config['teamUser'] = vm.teamUser
        config['schemaName'] = vm.schemaName
        vm.axios.post(endpoint, config)
          .then(function (response) {
            let obj = {
              title: 'Access granted!',
              type: 'success'
            }
            vm.$Simplert.open(obj)
            vm.response = response.data
            vm.updateActions(response.data.actions)
          })
          .catch(function (error) {
            let obj = {
              title: 'Failed to grant access!',
              message: error.response.data,
              type: 'error'
            }
            vm.$Simplert.open(obj)
            vm.response = error.response.data
            vm.updateActions(error.response.data.actions)
          })
      },
      generateSql: function () {
        let vm = this
        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/schema-access/generate-sql'
        var config = {}
        config['teamUser'] = vm.teamUser
        config['schemaName'] = vm.schemaName
        vm.actions = []
        vm.axios.post(endpoint, config)
          .then(function (response) {
            vm.showFeedback = false
            vm.response = response.data
            response.data.actions.forEach(function (key) {
              vm.actions.push(key)
            })
            let obj = {
              title: 'SQL generated!',
              type: 'success'
            }
            vm.$Simplert.open(obj)
            vm.resizeEditor()
          })
          .catch(function (error) {
            vm.response = error.response.data
            let obj = {
              title: 'Failed to generated SQL!',
              message: error,
              type: 'error'
            }
            vm.$Simplert.open(obj)
            vm.resizeEditor()
          })
      },
      updateActions: function (actionsParam) {
        let vm = this
        vm.actions = []
        actionsParam.forEach(function (key) {
          vm.actions.push(key)
        })
      },
      onCopy: function () {
        let vm = this
        let obj = {
          title: 'Copied to your clipboard!',
          message: 'Remember to execute the SQL generating statements',
          type: 'success'
        }
        vm.$Simplert.open(obj)
      },
      resizeEditor: function () {
        var newHeight = window.innerHeight
        var newWidth = 0
        if (this.$refs.resultsRef) {
          newWidth = this.$refs.resultsRef.clientWidth
        }
        this.textBlockWidth = Math.round(newWidth * 90 / 100)
        this.textBlockHeight = Math.round(newHeight * 60 / 100)
      },
      getApps: function (value) {
        let vm = this
        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/schema-access/app-schemas'
        let config = {}

        config['environment'] = vm.$parent.environment.name
        config['dataSource'] = value

        vm.loading = true
        vm.$parent.loading = true
        vm.axios.post(endpoint, config)
          .then(function (response) {
            vm.loading = false
            vm.$parent.loading = false
            vm.appList = response.data
            if (vm.appList.length <= 0) {
              let obj = {
                title: 'No database servers',
                message: 'There were no database servers found on ' + endpoint,
                type: 'error'
              }
              vm.$Simplert.open(obj)
            }
          })
          .catch(function (error) {
            vm.loading = false
            vm.$parent.loading = false
            console.log('error getting app-schemas')
            console.log(error.response)
            let obj = { title: 'Error', message: error.response, type: 'error' }
            vm.$Simplert.open(obj)
            vm.alertResponse(false, error.response.status, error.response.data)
          })
      },
      resetData: function () {
        this.appList = []
        this.teamUser = null
        this.dataSource = null
        this.schemaName = null
      }
    },
    created () {
      this.getDatabaseServers()
      this.getTeams()
      window.addEventListener('resize', this.resizeEditor)
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.resizeEditor)
    },
    watch: {
      'dataSource': function (newValue) {
        let vm = this
        if (newValue) {
          vm.getApps(newValue)
        }
      }
    },
    computed: {
      textBlock: function () {
        let vm = this
        if (vm.actions === null) {
          return ''
        }
        return vm.actions.join('\n')
      }
    }
  }
</script>
<style scoped>

  #resultsDiv {
    margin-top: 15px;
  }

  #copyToClipBtn {
    position: absolute;
    top: 5px;
    right: 5px;
  }

  #schema-access-info {
    margin-top: 10px;
  }
  
</style>



// WEBPACK FOOTER //
// SchemaAccess.vue?6a8b788a